export const version = "rlp/5.6.1";
//# sourceMappingURL=_version.js.map